var map = {
	"./badSealedCanal/11.png": 780623,
	"./badSealedCanal/12.png": 591199,
	"./badSealedCanal/13.png": 151418,
	"./badSealedCanal/14.png": 124969,
	"./badSealedCanal/15.png": 357068,
	"./badSealedCanal/16.png": 258550,
	"./badSealedCanal/17.png": 121815,
	"./badSealedCanal/18.png": 421814,
	"./badSealedCanal/21.png": 764913,
	"./badSealedCanal/22.png": 238788,
	"./badSealedCanal/23.png": 52244,
	"./badSealedCanal/24.png": 945951,
	"./badSealedCanal/25.png": 698115,
	"./badSealedCanal/26.png": 466489,
	"./badSealedCanal/27.png": 61074,
	"./badSealedCanal/28.png": 643804,
	"./badSealedCanal/31.png": 642179,
	"./badSealedCanal/32.png": 178419,
	"./badSealedCanal/33.png": 885446,
	"./badSealedCanal/34.png": 899869,
	"./badSealedCanal/35.png": 717700,
	"./badSealedCanal/36.png": 733114,
	"./badSealedCanal/37.png": 85505,
	"./badSealedCanal/38.png": 464377,
	"./badSealedCanal/41.png": 861587,
	"./badSealedCanal/42.png": 717878,
	"./badSealedCanal/43.png": 477973,
	"./badSealedCanal/44.png": 50854,
	"./badSealedCanal/45.png": 469129,
	"./badSealedCanal/46.png": 892575,
	"./badSealedCanal/47.png": 207605,
	"./badSealedCanal/48.png": 735150,
	"./base.png": 118899,
	"./base1.png": 428562,
	"./base2.png": 993831,
	"./base3.png": 455568,
	"./base4.png": 611161,
	"./boneAugmentation/11.png": 262372,
	"./boneAugmentation/12.png": 948199,
	"./boneAugmentation/13.png": 635229,
	"./boneAugmentation/14.png": 20552,
	"./boneAugmentation/15.png": 567436,
	"./boneAugmentation/16.png": 825732,
	"./boneAugmentation/17.png": 504234,
	"./boneAugmentation/18.png": 415682,
	"./boneAugmentation/21.png": 417162,
	"./boneAugmentation/22.png": 601609,
	"./boneAugmentation/23.png": 980538,
	"./boneAugmentation/24.png": 818534,
	"./boneAugmentation/25.png": 353821,
	"./boneAugmentation/26.png": 673472,
	"./boneAugmentation/27.png": 574406,
	"./boneAugmentation/28.png": 192100,
	"./boneAugmentation/31.png": 904538,
	"./boneAugmentation/32.png": 688826,
	"./boneAugmentation/33.png": 46440,
	"./boneAugmentation/34.png": 212599,
	"./boneAugmentation/35.png": 677407,
	"./boneAugmentation/36.png": 246168,
	"./boneAugmentation/37.png": 339006,
	"./boneAugmentation/38.png": 667444,
	"./boneAugmentation/41.png": 647848,
	"./boneAugmentation/42.png": 73481,
	"./boneAugmentation/43.png": 683241,
	"./boneAugmentation/44.png": 126673,
	"./boneAugmentation/45.png": 487367,
	"./boneAugmentation/46.png": 557207,
	"./boneAugmentation/47.png": 34133,
	"./boneAugmentation/48.png": 581008,
	"./brokenToolCanal/11.png": 169087,
	"./brokenToolCanal/12.png": 798242,
	"./brokenToolCanal/13.png": 763867,
	"./brokenToolCanal/14.png": 545394,
	"./brokenToolCanal/15.png": 674102,
	"./brokenToolCanal/16.png": 857511,
	"./brokenToolCanal/17.png": 916470,
	"./brokenToolCanal/18.png": 973634,
	"./brokenToolCanal/21.png": 178936,
	"./brokenToolCanal/22.png": 243930,
	"./brokenToolCanal/23.png": 867502,
	"./brokenToolCanal/24.png": 817718,
	"./brokenToolCanal/25.png": 526396,
	"./brokenToolCanal/26.png": 63212,
	"./brokenToolCanal/27.png": 905016,
	"./brokenToolCanal/28.png": 941553,
	"./brokenToolCanal/31.png": 818013,
	"./brokenToolCanal/32.png": 851809,
	"./brokenToolCanal/33.png": 809791,
	"./brokenToolCanal/34.png": 88299,
	"./brokenToolCanal/35.png": 649599,
	"./brokenToolCanal/36.png": 798790,
	"./brokenToolCanal/37.png": 343777,
	"./brokenToolCanal/38.png": 648804,
	"./brokenToolCanal/41.png": 966802,
	"./brokenToolCanal/42.png": 9436,
	"./brokenToolCanal/43.png": 805485,
	"./brokenToolCanal/44.png": 811714,
	"./brokenToolCanal/45.png": 447803,
	"./brokenToolCanal/46.png": 121955,
	"./brokenToolCanal/47.png": 731811,
	"./brokenToolCanal/48.png": 892761,
	"./cariousTooth/11.png": 468512,
	"./cariousTooth/12.png": 364662,
	"./cariousTooth/13.png": 643568,
	"./cariousTooth/14.png": 923813,
	"./cariousTooth/15.png": 470930,
	"./cariousTooth/16.png": 735467,
	"./cariousTooth/17.png": 41729,
	"./cariousTooth/18.png": 646810,
	"./cariousTooth/21.png": 296082,
	"./cariousTooth/22.png": 408155,
	"./cariousTooth/23.png": 352084,
	"./cariousTooth/24.png": 236897,
	"./cariousTooth/25.png": 835962,
	"./cariousTooth/26.png": 856307,
	"./cariousTooth/27.png": 37449,
	"./cariousTooth/28.png": 434052,
	"./cariousTooth/31.png": 881799,
	"./cariousTooth/32.png": 289450,
	"./cariousTooth/33.png": 828583,
	"./cariousTooth/34.png": 292343,
	"./cariousTooth/35.png": 75086,
	"./cariousTooth/36.png": 86726,
	"./cariousTooth/37.png": 59568,
	"./cariousTooth/38.png": 340267,
	"./cariousTooth/41.png": 542650,
	"./cariousTooth/42.png": 118901,
	"./cariousTooth/43.png": 234948,
	"./cariousTooth/44.png": 537601,
	"./cariousTooth/45.png": 290151,
	"./cariousTooth/46.png": 92089,
	"./cariousTooth/47.png": 597424,
	"./cariousTooth/48.png": 250171,
	"./connections/1112.png": 16138,
	"./connections/1213.png": 913586,
	"./connections/1314.png": 286196,
	"./connections/1415.png": 648063,
	"./connections/1516.png": 573805,
	"./connections/1617.png": 649730,
	"./connections/1718.png": 636370,
	"./connections/2111.png": 40492,
	"./connections/2221.png": 687162,
	"./connections/2322.png": 798430,
	"./connections/2423.png": 207891,
	"./connections/2524.png": 670550,
	"./connections/2625.png": 822777,
	"./connections/2726.png": 310427,
	"./connections/2827.png": 585005,
	"./connections/3132.png": 673115,
	"./connections/3233.png": 556031,
	"./connections/3334.png": 659393,
	"./connections/3435.png": 386564,
	"./connections/3536.png": 986809,
	"./connections/3637.png": 668175,
	"./connections/3738.png": 254476,
	"./connections/4131.png": 913381,
	"./connections/4241.png": 710046,
	"./connections/4342.png": 40313,
	"./connections/4443.png": 875440,
	"./connections/4544.png": 163055,
	"./connections/4645.png": 820530,
	"./connections/4746.png": 351249,
	"./connections/4847.png": 41554,
	"./decayedTooth/11.png": 773910,
	"./decayedTooth/12.png": 708561,
	"./decayedTooth/13.png": 460614,
	"./decayedTooth/14.png": 194209,
	"./decayedTooth/15.png": 604804,
	"./decayedTooth/16.png": 842747,
	"./decayedTooth/17.png": 431008,
	"./decayedTooth/18.png": 952125,
	"./decayedTooth/21.png": 601139,
	"./decayedTooth/22.png": 592496,
	"./decayedTooth/23.png": 257999,
	"./decayedTooth/24.png": 796413,
	"./decayedTooth/25.png": 620786,
	"./decayedTooth/26.png": 984498,
	"./decayedTooth/27.png": 848239,
	"./decayedTooth/28.png": 888159,
	"./decayedTooth/31.png": 831979,
	"./decayedTooth/32.png": 851967,
	"./decayedTooth/33.png": 961516,
	"./decayedTooth/34.png": 286101,
	"./decayedTooth/35.png": 833385,
	"./decayedTooth/36.png": 401114,
	"./decayedTooth/37.png": 913105,
	"./decayedTooth/38.png": 719449,
	"./decayedTooth/41.png": 350007,
	"./decayedTooth/42.png": 214966,
	"./decayedTooth/43.png": 97728,
	"./decayedTooth/44.png": 521363,
	"./decayedTooth/45.png": 23680,
	"./decayedTooth/46.png": 340014,
	"./decayedTooth/47.png": 182223,
	"./decayedTooth/48.png": 445190,
	"./dentalBar/11.png": 868257,
	"./dentalBar/12.png": 566101,
	"./dentalBar/13.png": 345499,
	"./dentalBar/14.png": 968337,
	"./dentalBar/15.png": 778149,
	"./dentalBar/16.png": 606751,
	"./dentalBar/17.png": 318927,
	"./dentalBar/21.png": 822407,
	"./dentalBar/22.png": 604773,
	"./dentalBar/23.png": 529423,
	"./dentalBar/24.png": 945331,
	"./dentalBar/25.png": 223237,
	"./dentalBar/26.png": 589665,
	"./dentalBar/27.png": 847073,
	"./dentalBar/31.png": 5669,
	"./dentalBar/32.png": 196987,
	"./dentalBar/33.png": 785035,
	"./dentalBar/34.png": 264369,
	"./dentalBar/35.png": 595908,
	"./dentalBar/36.png": 449787,
	"./dentalBar/37.png": 203532,
	"./dentalBar/41.png": 972615,
	"./dentalBar/42.png": 364299,
	"./dentalBar/43.png": 997474,
	"./dentalBar/44.png": 46392,
	"./dentalBar/45.png": 147822,
	"./dentalBar/46.png": 33308,
	"./dentalBar/47.png": 513576,
	"./emptyTooth/11.png": 222560,
	"./emptyTooth/12.png": 628795,
	"./emptyTooth/13.png": 588964,
	"./emptyTooth/14.png": 762365,
	"./emptyTooth/15.png": 481966,
	"./emptyTooth/16.png": 203773,
	"./emptyTooth/17.png": 154441,
	"./emptyTooth/18.png": 697113,
	"./emptyTooth/21.png": 951750,
	"./emptyTooth/22.png": 749709,
	"./emptyTooth/23.png": 903989,
	"./emptyTooth/24.png": 454781,
	"./emptyTooth/25.png": 436675,
	"./emptyTooth/26.png": 742568,
	"./emptyTooth/27.png": 832860,
	"./emptyTooth/28.png": 871744,
	"./emptyTooth/31.png": 564115,
	"./emptyTooth/32.png": 69495,
	"./emptyTooth/33.png": 798961,
	"./emptyTooth/34.png": 901921,
	"./emptyTooth/35.png": 981497,
	"./emptyTooth/36.png": 701275,
	"./emptyTooth/37.png": 693693,
	"./emptyTooth/38.png": 568951,
	"./emptyTooth/41.png": 224763,
	"./emptyTooth/42.png": 404705,
	"./emptyTooth/43.png": 588871,
	"./emptyTooth/44.png": 959332,
	"./emptyTooth/45.png": 711422,
	"./emptyTooth/46.png": 755634,
	"./emptyTooth/47.png": 599751,
	"./emptyTooth/48.png": 19355,
	"./gapsActionBtn/1112.png": 332836,
	"./gapsActionBtn/1213.png": 749368,
	"./gapsActionBtn/1314.png": 476270,
	"./gapsActionBtn/1415.png": 663350,
	"./gapsActionBtn/1516.png": 252470,
	"./gapsActionBtn/1617.png": 232686,
	"./gapsActionBtn/1718.png": 522141,
	"./gapsActionBtn/2111.png": 412720,
	"./gapsActionBtn/2221.png": 85802,
	"./gapsActionBtn/2322.png": 210068,
	"./gapsActionBtn/2423.png": 640306,
	"./gapsActionBtn/2524.png": 955897,
	"./gapsActionBtn/2625.png": 280344,
	"./gapsActionBtn/2726.png": 108676,
	"./gapsActionBtn/2827.png": 743455,
	"./gapsActionBtn/3132.png": 899763,
	"./gapsActionBtn/3233.png": 134055,
	"./gapsActionBtn/3334.png": 882914,
	"./gapsActionBtn/3435.png": 71101,
	"./gapsActionBtn/3536.png": 548706,
	"./gapsActionBtn/3637.png": 553395,
	"./gapsActionBtn/3738.png": 999656,
	"./gapsActionBtn/4131.png": 514212,
	"./gapsActionBtn/4241.png": 219261,
	"./gapsActionBtn/4342.png": 544942,
	"./gapsActionBtn/4443.png": 464463,
	"./gapsActionBtn/4544.png": 958225,
	"./gapsActionBtn/4645.png": 685454,
	"./gapsActionBtn/4746.png": 929303,
	"./gapsActionBtn/4847.png": 918482,
	"./gumBottom.png": 668728,
	"./gumTop.png": 362536,
	"./healthyTooth/11.png": 644696,
	"./healthyTooth/12.png": 48393,
	"./healthyTooth/13.png": 630226,
	"./healthyTooth/14.png": 365178,
	"./healthyTooth/15.png": 926548,
	"./healthyTooth/16.png": 731227,
	"./healthyTooth/17.png": 619380,
	"./healthyTooth/18.png": 118854,
	"./healthyTooth/21.png": 826447,
	"./healthyTooth/22.png": 316864,
	"./healthyTooth/23.png": 735501,
	"./healthyTooth/24.png": 863434,
	"./healthyTooth/25.png": 230069,
	"./healthyTooth/26.png": 985953,
	"./healthyTooth/27.png": 993939,
	"./healthyTooth/28.png": 476635,
	"./healthyTooth/31.png": 814289,
	"./healthyTooth/32.png": 23110,
	"./healthyTooth/33.png": 348602,
	"./healthyTooth/34.png": 160104,
	"./healthyTooth/35.png": 28841,
	"./healthyTooth/36.png": 799069,
	"./healthyTooth/37.png": 936623,
	"./healthyTooth/38.png": 7883,
	"./healthyTooth/41.png": 231434,
	"./healthyTooth/42.png": 608523,
	"./healthyTooth/43.png": 848449,
	"./healthyTooth/44.png": 874560,
	"./healthyTooth/45.png": 120945,
	"./healthyTooth/46.png": 664554,
	"./healthyTooth/47.png": 793880,
	"./healthyTooth/48.png": 25056,
	"./implantPosition/11.png": 632145,
	"./implantPosition/12.png": 440061,
	"./implantPosition/13.png": 686794,
	"./implantPosition/14.png": 208653,
	"./implantPosition/15.png": 831715,
	"./implantPosition/16.png": 900107,
	"./implantPosition/17.png": 901674,
	"./implantPosition/18.png": 357015,
	"./implantPosition/21.png": 297586,
	"./implantPosition/22.png": 668362,
	"./implantPosition/23.png": 553100,
	"./implantPosition/24.png": 616196,
	"./implantPosition/25.png": 836119,
	"./implantPosition/26.png": 362825,
	"./implantPosition/27.png": 303696,
	"./implantPosition/28.png": 993410,
	"./implantPosition/31.png": 886434,
	"./implantPosition/32.png": 8367,
	"./implantPosition/33.png": 837591,
	"./implantPosition/34.png": 778016,
	"./implantPosition/35.png": 832943,
	"./implantPosition/36.png": 226395,
	"./implantPosition/37.png": 408018,
	"./implantPosition/38.png": 259018,
	"./implantPosition/41.png": 246162,
	"./implantPosition/42.png": 941866,
	"./implantPosition/43.png": 79853,
	"./implantPosition/44.png": 743543,
	"./implantPosition/45.png": 766119,
	"./implantPosition/46.png": 998348,
	"./implantPosition/47.png": 186754,
	"./implantPosition/48.png": 657416,
	"./individualTitaniumAbutment/11.png": 962449,
	"./individualTitaniumAbutment/12.png": 770198,
	"./individualTitaniumAbutment/13.png": 966614,
	"./individualTitaniumAbutment/14.png": 750910,
	"./individualTitaniumAbutment/15.png": 707115,
	"./individualTitaniumAbutment/16.png": 733502,
	"./individualTitaniumAbutment/17.png": 364632,
	"./individualTitaniumAbutment/18.png": 454463,
	"./individualTitaniumAbutment/21.png": 556163,
	"./individualTitaniumAbutment/22.png": 315070,
	"./individualTitaniumAbutment/23.png": 589427,
	"./individualTitaniumAbutment/24.png": 759094,
	"./individualTitaniumAbutment/25.png": 426158,
	"./individualTitaniumAbutment/26.png": 687257,
	"./individualTitaniumAbutment/27.png": 880635,
	"./individualTitaniumAbutment/28.png": 307563,
	"./individualTitaniumAbutment/31.png": 885956,
	"./individualTitaniumAbutment/32.png": 282739,
	"./individualTitaniumAbutment/33.png": 941218,
	"./individualTitaniumAbutment/34.png": 413297,
	"./individualTitaniumAbutment/35.png": 462680,
	"./individualTitaniumAbutment/36.png": 157588,
	"./individualTitaniumAbutment/37.png": 314148,
	"./individualTitaniumAbutment/38.png": 615312,
	"./individualTitaniumAbutment/41.png": 557421,
	"./individualTitaniumAbutment/42.png": 270540,
	"./individualTitaniumAbutment/43.png": 250301,
	"./individualTitaniumAbutment/44.png": 188156,
	"./individualTitaniumAbutment/45.png": 715266,
	"./individualTitaniumAbutment/46.png": 107491,
	"./individualTitaniumAbutment/47.png": 30446,
	"./individualTitaniumAbutment/48.png": 533510,
	"./individualZirconiumAbutment/11.png": 657452,
	"./individualZirconiumAbutment/12.png": 456842,
	"./individualZirconiumAbutment/13.png": 227656,
	"./individualZirconiumAbutment/14.png": 719877,
	"./individualZirconiumAbutment/15.png": 659918,
	"./individualZirconiumAbutment/16.png": 216507,
	"./individualZirconiumAbutment/17.png": 843459,
	"./individualZirconiumAbutment/18.png": 969129,
	"./individualZirconiumAbutment/21.png": 639415,
	"./individualZirconiumAbutment/22.png": 254085,
	"./individualZirconiumAbutment/23.png": 941268,
	"./individualZirconiumAbutment/24.png": 360515,
	"./individualZirconiumAbutment/25.png": 637900,
	"./individualZirconiumAbutment/26.png": 535251,
	"./individualZirconiumAbutment/27.png": 218609,
	"./individualZirconiumAbutment/28.png": 780405,
	"./individualZirconiumAbutment/31.png": 238815,
	"./individualZirconiumAbutment/32.png": 368227,
	"./individualZirconiumAbutment/33.png": 674340,
	"./individualZirconiumAbutment/34.png": 706759,
	"./individualZirconiumAbutment/35.png": 102859,
	"./individualZirconiumAbutment/36.png": 474514,
	"./individualZirconiumAbutment/37.png": 553661,
	"./individualZirconiumAbutment/38.png": 217975,
	"./individualZirconiumAbutment/41.png": 756462,
	"./individualZirconiumAbutment/42.png": 770171,
	"./individualZirconiumAbutment/43.png": 381803,
	"./individualZirconiumAbutment/44.png": 47323,
	"./individualZirconiumAbutment/45.png": 368313,
	"./individualZirconiumAbutment/46.png": 961975,
	"./individualZirconiumAbutment/47.png": 736376,
	"./individualZirconiumAbutment/48.png": 496078,
	"./multiunitAbutment/11.png": 187471,
	"./multiunitAbutment/12.png": 780082,
	"./multiunitAbutment/13.png": 671865,
	"./multiunitAbutment/14.png": 395121,
	"./multiunitAbutment/15.png": 531130,
	"./multiunitAbutment/16.png": 706349,
	"./multiunitAbutment/17.png": 106566,
	"./multiunitAbutment/18.png": 724751,
	"./multiunitAbutment/21.png": 786549,
	"./multiunitAbutment/22.png": 107032,
	"./multiunitAbutment/23.png": 164489,
	"./multiunitAbutment/24.png": 593774,
	"./multiunitAbutment/25.png": 676970,
	"./multiunitAbutment/26.png": 857938,
	"./multiunitAbutment/27.png": 182835,
	"./multiunitAbutment/28.png": 695956,
	"./multiunitAbutment/31.png": 546374,
	"./multiunitAbutment/32.png": 577628,
	"./multiunitAbutment/33.png": 7185,
	"./multiunitAbutment/34.png": 503866,
	"./multiunitAbutment/35.png": 815311,
	"./multiunitAbutment/36.png": 324243,
	"./multiunitAbutment/37.png": 19532,
	"./multiunitAbutment/38.png": 905824,
	"./multiunitAbutment/41.png": 496251,
	"./multiunitAbutment/42.png": 533383,
	"./multiunitAbutment/43.png": 225349,
	"./multiunitAbutment/44.png": 310168,
	"./multiunitAbutment/45.png": 473303,
	"./multiunitAbutment/46.png": 652670,
	"./multiunitAbutment/47.png": 257701,
	"./multiunitAbutment/48.png": 668056,
	"./multiunitZirconiumAbutment/11.png": 961805,
	"./multiunitZirconiumAbutment/12.png": 423281,
	"./multiunitZirconiumAbutment/13.png": 266294,
	"./multiunitZirconiumAbutment/14.png": 191043,
	"./multiunitZirconiumAbutment/15.png": 457069,
	"./multiunitZirconiumAbutment/16.png": 192190,
	"./multiunitZirconiumAbutment/17.png": 829002,
	"./multiunitZirconiumAbutment/18.png": 360803,
	"./multiunitZirconiumAbutment/21.png": 833778,
	"./multiunitZirconiumAbutment/22.png": 254962,
	"./multiunitZirconiumAbutment/23.png": 300207,
	"./multiunitZirconiumAbutment/24.png": 997131,
	"./multiunitZirconiumAbutment/25.png": 163145,
	"./multiunitZirconiumAbutment/26.png": 396418,
	"./multiunitZirconiumAbutment/27.png": 687009,
	"./multiunitZirconiumAbutment/28.png": 270532,
	"./multiunitZirconiumAbutment/31.png": 801661,
	"./multiunitZirconiumAbutment/32.png": 952212,
	"./multiunitZirconiumAbutment/33.png": 563339,
	"./multiunitZirconiumAbutment/34.png": 976233,
	"./multiunitZirconiumAbutment/35.png": 566875,
	"./multiunitZirconiumAbutment/36.png": 601557,
	"./multiunitZirconiumAbutment/37.png": 250933,
	"./multiunitZirconiumAbutment/38.png": 741729,
	"./multiunitZirconiumAbutment/41.png": 290522,
	"./multiunitZirconiumAbutment/42.png": 487442,
	"./multiunitZirconiumAbutment/43.png": 687159,
	"./multiunitZirconiumAbutment/44.png": 311326,
	"./multiunitZirconiumAbutment/45.png": 27603,
	"./multiunitZirconiumAbutment/46.png": 609906,
	"./multiunitZirconiumAbutment/47.png": 952669,
	"./multiunitZirconiumAbutment/48.png": 976076,
	"./newEsteticTooth/11.png": 485018,
	"./newEsteticTooth/12.png": 618990,
	"./newEsteticTooth/13.png": 222525,
	"./newEsteticTooth/14.png": 489972,
	"./newEsteticTooth/15.png": 713312,
	"./newEsteticTooth/16.png": 183787,
	"./newEsteticTooth/17.png": 798072,
	"./newEsteticTooth/18.png": 597153,
	"./newEsteticTooth/21.png": 671366,
	"./newEsteticTooth/22.png": 188084,
	"./newEsteticTooth/23.png": 129016,
	"./newEsteticTooth/24.png": 152103,
	"./newEsteticTooth/25.png": 60074,
	"./newEsteticTooth/26.png": 358363,
	"./newEsteticTooth/27.png": 14541,
	"./newEsteticTooth/28.png": 276702,
	"./newEsteticTooth/31.png": 701302,
	"./newEsteticTooth/32.png": 61274,
	"./newEsteticTooth/33.png": 955594,
	"./newEsteticTooth/34.png": 350392,
	"./newEsteticTooth/35.png": 757398,
	"./newEsteticTooth/36.png": 908155,
	"./newEsteticTooth/37.png": 219776,
	"./newEsteticTooth/38.png": 458000,
	"./newEsteticTooth/41.png": 6453,
	"./newEsteticTooth/42.png": 692003,
	"./newEsteticTooth/43.png": 14402,
	"./newEsteticTooth/44.png": 833802,
	"./newEsteticTooth/45.png": 677429,
	"./newEsteticTooth/46.png": 922824,
	"./newEsteticTooth/47.png": 650885,
	"./newEsteticTooth/48.png": 978863,
	"./oldEsteticTooth/11.png": 73036,
	"./oldEsteticTooth/12.png": 614587,
	"./oldEsteticTooth/13.png": 241093,
	"./oldEsteticTooth/14.png": 55531,
	"./oldEsteticTooth/15.png": 760007,
	"./oldEsteticTooth/16.png": 905770,
	"./oldEsteticTooth/17.png": 223076,
	"./oldEsteticTooth/18.png": 736356,
	"./oldEsteticTooth/21.png": 672114,
	"./oldEsteticTooth/22.png": 923112,
	"./oldEsteticTooth/23.png": 204316,
	"./oldEsteticTooth/24.png": 862859,
	"./oldEsteticTooth/25.png": 380506,
	"./oldEsteticTooth/26.png": 299900,
	"./oldEsteticTooth/27.png": 712458,
	"./oldEsteticTooth/28.png": 347211,
	"./oldEsteticTooth/31.png": 706530,
	"./oldEsteticTooth/32.png": 705494,
	"./oldEsteticTooth/33.png": 643068,
	"./oldEsteticTooth/34.png": 556758,
	"./oldEsteticTooth/35.png": 77706,
	"./oldEsteticTooth/36.png": 901810,
	"./oldEsteticTooth/37.png": 731855,
	"./oldEsteticTooth/38.png": 946903,
	"./oldEsteticTooth/41.png": 102654,
	"./oldEsteticTooth/42.png": 292656,
	"./oldEsteticTooth/43.png": 888289,
	"./oldEsteticTooth/44.png": 76249,
	"./oldEsteticTooth/45.png": 699896,
	"./oldEsteticTooth/46.png": 324622,
	"./oldEsteticTooth/47.png": 145925,
	"./oldEsteticTooth/48.png": 227744,
	"./plasticCrown/11.png": 376354,
	"./plasticCrown/12.png": 722779,
	"./plasticCrown/13.png": 873388,
	"./plasticCrown/14.png": 738784,
	"./plasticCrown/15.png": 949606,
	"./plasticCrown/16.png": 28856,
	"./plasticCrown/17.png": 736117,
	"./plasticCrown/18.png": 870535,
	"./plasticCrown/21.png": 331466,
	"./plasticCrown/22.png": 409379,
	"./plasticCrown/23.png": 524399,
	"./plasticCrown/24.png": 564962,
	"./plasticCrown/25.png": 354597,
	"./plasticCrown/26.png": 707255,
	"./plasticCrown/27.png": 880853,
	"./plasticCrown/28.png": 385895,
	"./plasticCrown/31.png": 838073,
	"./plasticCrown/32.png": 717721,
	"./plasticCrown/33.png": 908983,
	"./plasticCrown/34.png": 149204,
	"./plasticCrown/35.png": 421601,
	"./plasticCrown/36.png": 115538,
	"./plasticCrown/37.png": 189946,
	"./plasticCrown/38.png": 4370,
	"./plasticCrown/41.png": 726281,
	"./plasticCrown/42.png": 830770,
	"./plasticCrown/43.png": 481265,
	"./plasticCrown/44.png": 392468,
	"./plasticCrown/45.png": 448399,
	"./plasticCrown/46.png": 542217,
	"./plasticCrown/47.png": 971340,
	"./plasticCrown/48.png": 133626,
	"./plasticTooth/11.png": 38983,
	"./plasticTooth/12.png": 812934,
	"./plasticTooth/13.png": 34198,
	"./plasticTooth/14.png": 127593,
	"./plasticTooth/15.png": 252074,
	"./plasticTooth/16.png": 705833,
	"./plasticTooth/17.png": 144273,
	"./plasticTooth/18.png": 840811,
	"./plasticTooth/21.png": 163146,
	"./plasticTooth/22.png": 385632,
	"./plasticTooth/23.png": 824474,
	"./plasticTooth/24.png": 562911,
	"./plasticTooth/25.png": 453942,
	"./plasticTooth/26.png": 98861,
	"./plasticTooth/27.png": 194715,
	"./plasticTooth/28.png": 149836,
	"./plasticTooth/31.png": 222502,
	"./plasticTooth/32.png": 186772,
	"./plasticTooth/33.png": 674491,
	"./plasticTooth/34.png": 62761,
	"./plasticTooth/35.png": 936547,
	"./plasticTooth/36.png": 368899,
	"./plasticTooth/37.png": 609690,
	"./plasticTooth/38.png": 4095,
	"./plasticTooth/41.png": 712337,
	"./plasticTooth/42.png": 216527,
	"./plasticTooth/43.png": 828976,
	"./plasticTooth/44.png": 27089,
	"./plasticTooth/45.png": 693439,
	"./plasticTooth/46.png": 576627,
	"./plasticTooth/47.png": 211327,
	"./plasticTooth/48.png": 533397,
	"./prosthesis/acrylicBottom.png": 341000,
	"./prosthesis/acrylicTop.png": 41412,
	"./prosthesis/clutchBottom.png": 470442,
	"./prosthesis/clutchTop.png": 6142,
	"./prosthesis/elastopositioner.png": 738649,
	"./prosthesis/orthodonticPlateBottom.png": 684523,
	"./prosthesis/orthodonticPlateTop.png": 459246,
	"./prosthesis/slideCeramicBracesBottom.png": 277501,
	"./prosthesis/slideCeramicBracesTop.png": 951477,
	"./prosthesis/slideCeramicSelfAlignBracesBottom.png": 486578,
	"./prosthesis/slideCeramicSelfAlignBracesTop.png": 363636,
	"./prosthesis/slideLingualBracesBottom.png": 286887,
	"./prosthesis/slideLingualBracesTop.png": 168147,
	"./prosthesis/slideMetallBracesBottom.png": 716753,
	"./prosthesis/slideMetallBracesTop.png": 81786,
	"./prosthesis/slideMouthAlignerBottom.png": 103252,
	"./prosthesis/slideMouthAlignerTop.png": 453206,
	"./prosthesis/slideNoAlignSystemBottom.png": 405207,
	"./prosthesis/slideNoAlignSystemTop.png": 799597,
	"./prosthesis/slideSapphireBracesBottom.png": 340566,
	"./prosthesis/slideSapphireBracesTop.png": 739950,
	"./prosthesis/slideSelfAlignBracesBottom.png": 530034,
	"./prosthesis/slideSelfAlignBracesTop.png": 490170,
	"./prosthesis/totalBottom.png": 484307,
	"./prosthesis/totalTop.png": 463152,
	"./prostheticsTooth/11.png": 886945,
	"./prostheticsTooth/12.png": 57180,
	"./prostheticsTooth/13.png": 159421,
	"./prostheticsTooth/14.png": 693594,
	"./prostheticsTooth/15.png": 60946,
	"./prostheticsTooth/16.png": 750687,
	"./prostheticsTooth/17.png": 14247,
	"./prostheticsTooth/18.png": 933903,
	"./prostheticsTooth/21.png": 296412,
	"./prostheticsTooth/22.png": 250459,
	"./prostheticsTooth/23.png": 981010,
	"./prostheticsTooth/24.png": 208625,
	"./prostheticsTooth/25.png": 432549,
	"./prostheticsTooth/26.png": 39884,
	"./prostheticsTooth/27.png": 564982,
	"./prostheticsTooth/28.png": 596850,
	"./prostheticsTooth/31.png": 165932,
	"./prostheticsTooth/32.png": 722041,
	"./prostheticsTooth/33.png": 439328,
	"./prostheticsTooth/34.png": 445189,
	"./prostheticsTooth/35.png": 32693,
	"./prostheticsTooth/36.png": 495836,
	"./prostheticsTooth/37.png": 509161,
	"./prostheticsTooth/38.png": 132808,
	"./prostheticsTooth/41.png": 148786,
	"./prostheticsTooth/42.png": 556905,
	"./prostheticsTooth/43.png": 864530,
	"./prostheticsTooth/44.png": 215481,
	"./prostheticsTooth/45.png": 868493,
	"./prostheticsTooth/46.png": 821014,
	"./prostheticsTooth/47.png": 181528,
	"./prostheticsTooth/48.png": 527309,
	"./pulpitis/11.png": 629007,
	"./pulpitis/12.png": 875213,
	"./pulpitis/13.png": 561029,
	"./pulpitis/14.png": 807216,
	"./pulpitis/15.png": 24754,
	"./pulpitis/16.png": 40143,
	"./pulpitis/17.png": 918158,
	"./pulpitis/18.png": 949770,
	"./pulpitis/21.png": 368976,
	"./pulpitis/22.png": 49529,
	"./pulpitis/23.png": 501908,
	"./pulpitis/24.png": 273531,
	"./pulpitis/25.png": 287693,
	"./pulpitis/26.png": 410446,
	"./pulpitis/27.png": 439144,
	"./pulpitis/28.png": 287505,
	"./pulpitis/31.png": 736234,
	"./pulpitis/32.png": 85415,
	"./pulpitis/33.png": 108291,
	"./pulpitis/34.png": 161271,
	"./pulpitis/35.png": 783751,
	"./pulpitis/36.png": 422797,
	"./pulpitis/37.png": 692122,
	"./pulpitis/38.png": 350591,
	"./pulpitis/41.png": 322457,
	"./pulpitis/42.png": 101913,
	"./pulpitis/43.png": 776134,
	"./pulpitis/44.png": 550031,
	"./pulpitis/45.png": 542950,
	"./pulpitis/46.png": 551185,
	"./pulpitis/47.png": 835769,
	"./pulpitis/48.png": 913062,
	"./screwFixationImplants/11.png": 741376,
	"./screwFixationImplants/12.png": 114011,
	"./screwFixationImplants/13.png": 277062,
	"./screwFixationImplants/14.png": 736688,
	"./screwFixationImplants/15.png": 330251,
	"./screwFixationImplants/16.png": 427629,
	"./screwFixationImplants/17.png": 919840,
	"./screwFixationImplants/18.png": 798165,
	"./screwFixationImplants/21.png": 989957,
	"./screwFixationImplants/22.png": 881662,
	"./screwFixationImplants/23.png": 822412,
	"./screwFixationImplants/24.png": 135791,
	"./screwFixationImplants/25.png": 926911,
	"./screwFixationImplants/26.png": 561702,
	"./screwFixationImplants/27.png": 800291,
	"./screwFixationImplants/28.png": 825222,
	"./screwFixationImplants/31.png": 703633,
	"./screwFixationImplants/32.png": 281653,
	"./screwFixationImplants/33.png": 958405,
	"./screwFixationImplants/34.png": 14568,
	"./screwFixationImplants/35.png": 677031,
	"./screwFixationImplants/36.png": 179946,
	"./screwFixationImplants/37.png": 560487,
	"./screwFixationImplants/38.png": 505647,
	"./screwFixationImplants/41.png": 873478,
	"./screwFixationImplants/42.png": 568151,
	"./screwFixationImplants/43.png": 744868,
	"./screwFixationImplants/44.png": 822917,
	"./screwFixationImplants/45.png": 121713,
	"./screwFixationImplants/46.png": 127465,
	"./screwFixationImplants/47.png": 885941,
	"./screwFixationImplants/48.png": 234951,
	"./sealedCanal/11.png": 506434,
	"./sealedCanal/12.png": 513371,
	"./sealedCanal/13.png": 370048,
	"./sealedCanal/14.png": 385808,
	"./sealedCanal/15.png": 784158,
	"./sealedCanal/16.png": 478045,
	"./sealedCanal/17.png": 220794,
	"./sealedCanal/18.png": 115841,
	"./sealedCanal/21.png": 237159,
	"./sealedCanal/22.png": 48968,
	"./sealedCanal/23.png": 591834,
	"./sealedCanal/24.png": 49088,
	"./sealedCanal/25.png": 435865,
	"./sealedCanal/26.png": 309179,
	"./sealedCanal/27.png": 793309,
	"./sealedCanal/28.png": 456129,
	"./sealedCanal/31.png": 37306,
	"./sealedCanal/32.png": 791748,
	"./sealedCanal/33.png": 917005,
	"./sealedCanal/34.png": 492077,
	"./sealedCanal/35.png": 963506,
	"./sealedCanal/36.png": 739991,
	"./sealedCanal/37.png": 247049,
	"./sealedCanal/38.png": 197570,
	"./sealedCanal/41.png": 831726,
	"./sealedCanal/42.png": 819935,
	"./sealedCanal/43.png": 852669,
	"./sealedCanal/44.png": 564743,
	"./sealedCanal/45.png": 599336,
	"./sealedCanal/46.png": 517861,
	"./sealedCanal/47.png": 417024,
	"./sealedCanal/48.png": 598341,
	"./stumpTabs/11.png": 90099,
	"./stumpTabs/12.png": 553245,
	"./stumpTabs/13.png": 929386,
	"./stumpTabs/14.png": 328120,
	"./stumpTabs/15.png": 52949,
	"./stumpTabs/16.png": 233813,
	"./stumpTabs/17.png": 364807,
	"./stumpTabs/18.png": 770078,
	"./stumpTabs/21.png": 638926,
	"./stumpTabs/22.png": 634055,
	"./stumpTabs/23.png": 23598,
	"./stumpTabs/24.png": 795869,
	"./stumpTabs/25.png": 801591,
	"./stumpTabs/26.png": 191416,
	"./stumpTabs/27.png": 424666,
	"./stumpTabs/28.png": 474198,
	"./stumpTabs/31.png": 217093,
	"./stumpTabs/32.png": 674536,
	"./stumpTabs/33.png": 237641,
	"./stumpTabs/34.png": 661220,
	"./stumpTabs/35.png": 223499,
	"./stumpTabs/36.png": 151375,
	"./stumpTabs/37.png": 596675,
	"./stumpTabs/38.png": 837964,
	"./stumpTabs/41.png": 87733,
	"./stumpTabs/42.png": 619739,
	"./stumpTabs/43.png": 197834,
	"./stumpTabs/44.png": 611306,
	"./stumpTabs/45.png": 699820,
	"./stumpTabs/46.png": 259465,
	"./stumpTabs/47.png": 988849,
	"./stumpTabs/48.png": 233868,
	"./syntheticGum/11.png": 878082,
	"./syntheticGum/12.png": 152997,
	"./syntheticGum/13.png": 270009,
	"./syntheticGum/14.png": 889600,
	"./syntheticGum/15.png": 739673,
	"./syntheticGum/16.png": 434149,
	"./syntheticGum/17.png": 428140,
	"./syntheticGum/18.png": 853089,
	"./syntheticGum/21.png": 673377,
	"./syntheticGum/22.png": 783795,
	"./syntheticGum/23.png": 853053,
	"./syntheticGum/24.png": 477212,
	"./syntheticGum/25.png": 527019,
	"./syntheticGum/26.png": 292283,
	"./syntheticGum/27.png": 145416,
	"./syntheticGum/28.png": 103703,
	"./syntheticGum/31.png": 752559,
	"./syntheticGum/32.png": 657154,
	"./syntheticGum/33.png": 757956,
	"./syntheticGum/34.png": 138629,
	"./syntheticGum/35.png": 564411,
	"./syntheticGum/36.png": 248962,
	"./syntheticGum/37.png": 365618,
	"./syntheticGum/38.png": 63232,
	"./syntheticGum/41.png": 495673,
	"./syntheticGum/42.png": 64506,
	"./syntheticGum/43.png": 194297,
	"./syntheticGum/44.png": 692154,
	"./syntheticGum/45.png": 265810,
	"./syntheticGum/46.png": 300185,
	"./syntheticGum/47.png": 757613,
	"./syntheticGum/48.png": 384843,
	"./telescopicCrown/11.png": 58512,
	"./telescopicCrown/12.png": 482586,
	"./telescopicCrown/13.png": 328657,
	"./telescopicCrown/14.png": 844829,
	"./telescopicCrown/15.png": 844959,
	"./telescopicCrown/16.png": 913509,
	"./telescopicCrown/17.png": 233403,
	"./telescopicCrown/18.png": 763936,
	"./telescopicCrown/21.png": 552823,
	"./telescopicCrown/22.png": 435880,
	"./telescopicCrown/23.png": 20119,
	"./telescopicCrown/24.png": 122662,
	"./telescopicCrown/25.png": 280769,
	"./telescopicCrown/26.png": 94804,
	"./telescopicCrown/27.png": 451076,
	"./telescopicCrown/28.png": 430477,
	"./telescopicCrown/31.png": 875200,
	"./telescopicCrown/32.png": 204449,
	"./telescopicCrown/33.png": 816997,
	"./telescopicCrown/34.png": 159995,
	"./telescopicCrown/35.png": 30671,
	"./telescopicCrown/36.png": 858147,
	"./telescopicCrown/37.png": 867682,
	"./telescopicCrown/38.png": 619644,
	"./telescopicCrown/41.png": 172130,
	"./telescopicCrown/42.png": 177769,
	"./telescopicCrown/43.png": 25933,
	"./telescopicCrown/44.png": 467364,
	"./telescopicCrown/45.png": 905565,
	"./telescopicCrown/46.png": 970084,
	"./telescopicCrown/47.png": 832350,
	"./telescopicCrown/48.png": 154679,
	"./therapyRestoration/11.png": 922285,
	"./therapyRestoration/12.png": 251440,
	"./therapyRestoration/13.png": 905028,
	"./therapyRestoration/14.png": 289186,
	"./therapyRestoration/15.png": 839119,
	"./therapyRestoration/16.png": 607744,
	"./therapyRestoration/17.png": 844323,
	"./therapyRestoration/18.png": 20538,
	"./therapyRestoration/21.png": 121348,
	"./therapyRestoration/22.png": 903388,
	"./therapyRestoration/23.png": 426548,
	"./therapyRestoration/24.png": 727373,
	"./therapyRestoration/25.png": 676345,
	"./therapyRestoration/26.png": 622455,
	"./therapyRestoration/27.png": 299339,
	"./therapyRestoration/28.png": 507707,
	"./therapyRestoration/31.png": 84718,
	"./therapyRestoration/32.png": 270822,
	"./therapyRestoration/33.png": 497313,
	"./therapyRestoration/34.png": 134273,
	"./therapyRestoration/35.png": 230383,
	"./therapyRestoration/36.png": 375082,
	"./therapyRestoration/37.png": 376334,
	"./therapyRestoration/38.png": 683874,
	"./therapyRestoration/41.png": 265686,
	"./therapyRestoration/42.png": 704255,
	"./therapyRestoration/43.png": 55546,
	"./therapyRestoration/44.png": 18909,
	"./therapyRestoration/45.png": 301840,
	"./therapyRestoration/46.png": 176191,
	"./therapyRestoration/47.png": 548288,
	"./therapyRestoration/48.png": 463433,
	"./toothStumpRestoration/11.png": 326586,
	"./toothStumpRestoration/12.png": 802313,
	"./toothStumpRestoration/13.png": 350750,
	"./toothStumpRestoration/14.png": 407493,
	"./toothStumpRestoration/15.png": 31117,
	"./toothStumpRestoration/16.png": 899937,
	"./toothStumpRestoration/17.png": 939638,
	"./toothStumpRestoration/18.png": 893671,
	"./toothStumpRestoration/21.png": 461286,
	"./toothStumpRestoration/22.png": 201173,
	"./toothStumpRestoration/23.png": 666296,
	"./toothStumpRestoration/24.png": 735170,
	"./toothStumpRestoration/25.png": 950234,
	"./toothStumpRestoration/26.png": 98886,
	"./toothStumpRestoration/27.png": 412450,
	"./toothStumpRestoration/28.png": 870939,
	"./toothStumpRestoration/31.png": 821345,
	"./toothStumpRestoration/32.png": 983923,
	"./toothStumpRestoration/33.png": 468973,
	"./toothStumpRestoration/34.png": 715080,
	"./toothStumpRestoration/35.png": 79543,
	"./toothStumpRestoration/36.png": 707560,
	"./toothStumpRestoration/37.png": 571937,
	"./toothStumpRestoration/38.png": 672912,
	"./toothStumpRestoration/41.png": 671920,
	"./toothStumpRestoration/42.png": 969938,
	"./toothStumpRestoration/43.png": 719776,
	"./toothStumpRestoration/44.png": 930560,
	"./toothStumpRestoration/45.png": 337151,
	"./toothStumpRestoration/46.png": 446663,
	"./toothStumpRestoration/47.png": 680481,
	"./toothStumpRestoration/48.png": 63744,
	"./treatedCanal/11.png": 170287,
	"./treatedCanal/12.png": 228417,
	"./treatedCanal/13.png": 113624,
	"./treatedCanal/14.png": 359195,
	"./treatedCanal/15.png": 167434,
	"./treatedCanal/16.png": 465541,
	"./treatedCanal/17.png": 560147,
	"./treatedCanal/18.png": 885955,
	"./treatedCanal/21.png": 819944,
	"./treatedCanal/22.png": 712455,
	"./treatedCanal/23.png": 988543,
	"./treatedCanal/24.png": 164207,
	"./treatedCanal/25.png": 858475,
	"./treatedCanal/26.png": 493630,
	"./treatedCanal/27.png": 342701,
	"./treatedCanal/28.png": 506471,
	"./treatedCanal/31.png": 216853,
	"./treatedCanal/32.png": 777309,
	"./treatedCanal/33.png": 884476,
	"./treatedCanal/34.png": 366501,
	"./treatedCanal/35.png": 539191,
	"./treatedCanal/36.png": 630088,
	"./treatedCanal/37.png": 642279,
	"./treatedCanal/38.png": 194009,
	"./treatedCanal/41.png": 694511,
	"./treatedCanal/42.png": 259235,
	"./treatedCanal/43.png": 891408,
	"./treatedCanal/44.png": 503771,
	"./treatedCanal/45.png": 857218,
	"./treatedCanal/46.png": 775917,
	"./treatedCanal/47.png": 312596,
	"./treatedCanal/48.png": 949299,
	"./veneerTab/11.png": 870673,
	"./veneerTab/12.png": 941514,
	"./veneerTab/13.png": 9389,
	"./veneerTab/14.png": 413679,
	"./veneerTab/15.png": 991893,
	"./veneerTab/16.png": 857773,
	"./veneerTab/17.png": 165029,
	"./veneerTab/21.png": 906567,
	"./veneerTab/22.png": 793530,
	"./veneerTab/23.png": 377960,
	"./veneerTab/24.png": 777512,
	"./veneerTab/25.png": 182652,
	"./veneerTab/26.png": 517180,
	"./veneerTab/27.png": 401107,
	"./veneerTab/31.png": 780012,
	"./veneerTab/32.png": 137733,
	"./veneerTab/33.png": 634119,
	"./veneerTab/34.png": 575873,
	"./veneerTab/35.png": 549497,
	"./veneerTab/36.png": 105956,
	"./veneerTab/37.png": 159900,
	"./veneerTab/41.png": 925967,
	"./veneerTab/42.png": 906076,
	"./veneerTab/43.png": 817640,
	"./veneerTab/44.png": 95032,
	"./veneerTab/45.png": 23397,
	"./veneerTab/46.png": 239108,
	"./veneerTab/47.png": 38273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32058;